// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"219720f1","549":"580ec286"}[chunkId] + ".chunk.js";
};